<template>
  <FullWidthLayout>
    <template #site-header>
      <SiteHeader class="mb-0 bg-secondary" />
    </template>
    <RouterView
      v-slot="{ Component }"
      :key="`${$route.params.jobId}-${locale}`"
    >
      <PageTransition transition="fade">
        <div>
          <Spinner
            v-if="appStateStore.loading || !ldReady || loadingLocale"
            fullscreen
          />
          <component
            :is="Component"
            v-else
          />
        </div>
      </PageTransition>
    </RouterView>
  </FullWidthLayout>
  <div id="modal-target"></div>
</template>

<script setup lang="ts">
import SiteHeader from '@/components/SiteHeader.vue';
import { localeMessageLoaders } from '@/i18n';
import { useAppStore } from '@/store/appState';
import PageTransition from '@shared/components/PageTransition.vue';
import Spinner from '@shared/components/Spinner.vue';
import { useUserLocale } from '@shared/composables/useUserLocale';
import FullWidthLayout from '@shared/layouts/FullWidthLayout.vue';
import { useLDReady } from 'launchdarkly-vue-client-sdk';
import { RouterView } from 'vue-router';

const appStateStore = useAppStore();
const ldReady = useLDReady();
// Pages re-mount on a locale change so strings resolved once at setup pick up the new language
const { locale, loadingLocale } = useUserLocale(localeMessageLoaders);
</script>
<style lang="scss">
@import '@/assets/scss/_app.scss';
</style>
